import type LogRocket from "logrocket";

export let logrocket: typeof LogRocket;
if (import.meta.env.VITE_LOGROCKET_ID) {
  import("logrocket").then(({ default: LogRocket }) => {
    logrocket = LogRocket;
    console.log({ logrocket, id: import.meta.env.VITE_LOGROCKET_ID });
    LogRocket.init(import.meta.env.VITE_LOGROCKET_ID);
  });
}
